import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { legacyRemCss } from 'helpers/legacyRem';

const Progress = (props) => {
  const { id, value, background, rounded, className } = props;

  return (
    <svg
      id={`bar_${id}`}
      className={clsx('progressBar', className)}
      style={{
        backgroundColor: background === true ? '#000' : background,
        borderRadius: rounded === true ? legacyRemCss(5) : rounded,
      }}
      viewBox="0 1 100 1"
      preserveAspectRatio="none"
    >
      <path id={`bar_path_${id}`} d={`M0 1 L${value} 1`} className="progressValue" />
    </svg>
  );
};

export default Progress;

Progress.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.number,
  background: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  rounded: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
};

Progress.defaultProps = {
  value: 0,
  background: null,
  rounded: null,
  className: undefined,
};
